import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Details = () => {
  return (
    <Box margin={{ xs: "25% 0% 10% 0%", sm: "5% 0% 2% 0%" }}>
      <Typography
        variant="h4"
        color="#317ABE"
        fontWeight={800}
        paddingBottom={"3%"}
        textAlign={"left"}
      >
        Aquaculture Intervention Program (AIP)
      </Typography>
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "48%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          paddingRight={{ xs: "0%", sm: "2%" }}
          data-aos={"fade-up"}
        >
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            A growing industry as the aquaculture needs not just women and
            youths, but also young people who can participate in that growth and
            can engage early in good aquaculture practices.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            Blue-Echo Foundation has begun that journey of inclusion by
            targeting Secondary School students and introducing them to the
            aquaculture industry. An initiative called “Aquaculture Intervention
            Program (AIP)” is being implemented in selected secondary schools
            and will teach students in basic fish farming techniques and pond
            management to empower them with requisite skills in aquaculture. The
            initiative will make beneficiaries self-reliant, increase household
            fish consumption, and reduce poverty amongst others.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
          >
            The AIP will not only engage the students in class, they will be
            given the opportunity for hands-on training in their own fish tanks
            donated to the schools.
          </Typography>
        </Box>
        <Box
          width={{ xs: "100%", sm: "48%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "5%", sm: "0%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
          >
            Blue-Echo Foundation will provide the selected schools with starter
            packs including fish seeds, feeds and tanks and also offer
            monitoring and mentorship to foster sustainability.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
          >
            Our Aquaculture Intervention for Secondary Schools has built the
            capacity and empowered students in the following schools by
            transferring knowledge in aquaculture and fish management practices
            to them at a young age.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"1%"}
          >
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9998;{" "}
            </Typography>
            Abeokuta Girls Grammar School (AGGS), Abeokuta
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"1%"}
          >
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9998;{" "}
            </Typography>
            Agunbiade Victory High School (AVHS), Abeokuta
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"1%"}
          >
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9998;{" "}
            </Typography>
            Baptist Boys High School (BBHS), Abeokuta
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"1%"}
          >
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9998;{" "}
            </Typography>
            Elyon College Leadership Academy (ECLA), Abeokuta
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Details;
